import { lazy, Suspense } from 'react';

import { Hero } from '@/components/landing/Hero';
import { MarketingHeader } from '@/components/landing/MarketingHeader';

const FeaturedItineraries = lazy(async () => {
  const module = await import('@/components/landing/FeaturedItineraries');
  return { default: module.FeaturedItineraries };
});
const FeatureStrip = lazy(async () => {
  const module = await import('@/components/landing/FeatureStrip');
  return { default: module.FeatureStrip };
});
const HowItWorks = lazy(async () => {
  const module = await import('@/components/landing/HowItWorks');
  return { default: module.HowItWorks };
});
const FeaturesGrid = lazy(async () => {
  const module = await import('@/components/landing/FeaturesGrid');
  return { default: module.FeaturesGrid };
});
const TrustSection = lazy(async () => {
  const module = await import('@/components/landing/TrustSection');
  return { default: module.TrustSection };
});
const CTABand = lazy(async () => {
  const module = await import('@/components/landing/CTABand');
  return { default: module.CTABand };
});
const FAQ = lazy(async () => {
  const module = await import('@/components/landing/FAQ');
  return { default: module.FAQ };
});
const FinalCTA = lazy(async () => {
  const module = await import('@/components/landing/FinalCTA');
  return { default: module.FinalCTA };
});
const StickyCTA = lazy(async () => {
  const module = await import('@/components/landing/StickyCTA');
  return { default: module.StickyCTA };
});
const Footer = lazy(async () => {
  const module = await import('@/components/landing/Footer');
  return { default: module.Footer };
});

function BelowFold({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={null}>{children}</Suspense>;
}

export function LandingPage() {
  return (
    <>
      <MarketingHeader />
      <Hero />
      <BelowFold>
        <FeaturedItineraries />
        <FeatureStrip />
        <HowItWorks />
        <FeaturesGrid />
        <TrustSection />
        <CTABand />
        <FAQ />
        <FinalCTA />
        <Footer />
        <StickyCTA />
      </BelowFold>
    </>
  );
}
